export const LanguagesEnum = Object.freeze({
  EN: 'en',
  NL: 'nl',
})